import dayjs, { ConfigType } from 'dayjs'
import {
  CurrentUserPaymentMethodType,
  DonationRecurrenceInterval,
} from '~/types/graphql'
import { formatTime } from '~/components/time'
import { typedOptions } from '~/utils/ts-utils'

const RECURRENCE_INTERVAL_LABELS: Record<DonationRecurrenceInterval, string> = {
  [DonationRecurrenceInterval.None]: 'One-Time',
  [DonationRecurrenceInterval.Monthly]: 'Monthly',
  [DonationRecurrenceInterval.Quarterly]: 'Quarterly',
  [DonationRecurrenceInterval.TwiceAYear]: 'Biannually',
  [DonationRecurrenceInterval.Yearly]: 'Yearly'
}

export const PAYMENT_METHOD_TYPE_LABELS: Partial<
  Record<CurrentUserPaymentMethodType, string>
> = {
  [CurrentUserPaymentMethodType.Card]: 'Card',
  [CurrentUserPaymentMethodType.BankAccount]: 'Bank account (ACH)',
  [CurrentUserPaymentMethodType.DonorAdvisedFund]: 'Donor advised fund',
}

// Stripe sends the brand in lower case. Anything not listed is capitalized.
const CARD_BRAND_LABELS: Record<string, string> = {
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
}

export const formatCardBrand = (brand: string) =>
  CARD_BRAND_LABELS[brand] ?? brand.charAt(0).toUpperCase() + brand.slice(1)

const RECURRENCE_INTERVAL_MONTHS: Record<DonationRecurrenceInterval, number> = {
  [DonationRecurrenceInterval.None]: 0,
  [DonationRecurrenceInterval.Monthly]: 1,
  [DonationRecurrenceInterval.Quarterly]: 3,
  [DonationRecurrenceInterval.TwiceAYear]: 6,
  [DonationRecurrenceInterval.Yearly]: 12
}

export const getDonationRecurrenceIntervalLabel = (interval: DonationRecurrenceInterval) => {
  return RECURRENCE_INTERVAL_LABELS[interval] ?? RECURRENCE_INTERVAL_LABELS[DonationRecurrenceInterval.None]
}

export const getRecurringIntervalOptions = (omit: DonationRecurrenceInterval[]) =>
  typedOptions(RECURRENCE_INTERVAL_LABELS).filter(({ value }) => !omit.includes(value))

export const getIntervalMonths = (interval: DonationRecurrenceInterval) => {
  return RECURRENCE_INTERVAL_MONTHS[interval]
}

export const adjustDateByInterval = (date: number | null | undefined, interval: DonationRecurrenceInterval) => {
  if(!date){
    return null
  }

  const months = getIntervalMonths(interval)

  return dayjs(date).add(months, 'month').valueOf()
}

export const formatPaymentDate = (date?: number | null, now?: ConfigType) => {
  if (!date) {
    return 'Not scheduled'
  }

  if(dayjs(date).isSame(dayjs(now), 'day')){
    return 'Today'
  }

  return formatTime(date, 'LL')
}
